/**
 * Menús de primer nivel que el home-header muestra como accesos fijos en su
 * barra de navegación, en este orden. El explorador de Apps los excluye para
 * no repetir lo que ya está siempre a mano en el header.
 */
export const HOME_NAV_URLS: readonly string[] = [
  'pages/home',
  'news',
  'dashboards',
  //'apps/repositories',
  'apps/headquarters',
  'apps/collections'
];
